import React from 'react';

import { useVideoContext, usePlayer, UiEvents } from '@loomhq/createhq';
import { parseComments } from './utils/model';

import { CommentPost } from '@loomhq/createhq/dist/video-player/context';
import { VIDEO_COMMENT_CREATED } from 'constants/events';
import { useCreateComment, useFetchComments } from './hooks/comments';

const CommentsHandler = (): null => {
  const { setComments, video } = useVideoContext();
  const { comments } = useFetchComments();
  const player = usePlayer(video.id);

  const createComment = useCreateComment();

  const handleComment = (payload: CommentPost) => {
    createComment({
      content: payload.content,
    });

    analytics.track(VIDEO_COMMENT_CREATED, {
      video_id: video.modelId,
      comment_length: payload.content.length,
      freshPlayer: true,
    });
  };

  // when comments change, update the player context
  React.useEffect(() => {
    if (comments) {
      setComments(parseComments(comments));
    }
  }, [setComments, comments]);

  // register for new comment event
  React.useEffect(() => {
    player?.on([UiEvents.newComment], handleComment);

    return () => {
      player?.off([UiEvents.newComment], handleComment);
    };
  }, [player]);

  return null;
};

export default CommentsHandler;
